export { VehicleView } from './VehicleView'
export type { VehicleViewProps } from './VehicleView'
